import * as React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import * as rsuite from "rsuite";
import "rsuite/dist/rsuite-rtl.min.css";
import { trackPromise } from "react-promise-tracker";
import * as ReactDOM from 'react-router-dom';
import { Modal } from "react-bootstrap";
import axios from "axios";
import * as General from "../Business/General/General.js";
import AnimatedNavbar from "./AnimatedNavbar.js"
import MobNavbar from "./MobNavbar.js"
import { isBrowser } from 'react-device-detect';
import styled from "styled-components"
import "./Style.css"
import { ReactSocialMediaIcons } from 'react-social-media-icons';
import { Helmet } from "react-helmet";

const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "فارم آسان",
    "alternateName": [
        "فارم اسان",
        "FarmAsan",
        "Farm Asan"
    ],
    "url": "https://farmasan.ir",
    "logo": "https://farmasan.ir/assets/images/Logo.png",
    "description": "بازرگانی فارم آسان؛ عرضه‌کننده انواع تجهیزات کشاورزی، موتور برق، پمپ، کارواش، سمپاش و ابزار صنعتی.",
    "telephone": "+987132221005",
    "contactPoint": [
        {
            "@type": "ContactPoint",
            "telephone": [
                "+987132221005",
                "+987132221143"
            ],
            "contactType": "sales",
            "areaServed": "IR",
            "availableLanguage": ["fa", "en"]
        },
        {
            "@type": "ContactPoint",
            "telephone": "+989101172004",
            "contactType": "sales",
            "areaServed": "IR",
            "availableLanguage": ["fa", "en"]
        },
        {
            "@type": "ContactPoint",
            "telephone": "+989357105608",
            "contactType": "customer service",
            "areaServed": "IR",
            "availableLanguage": ["fa", "en"]
        }
    ],
    "address": {
        "@type": "PostalAddress",
        "streetAddress": " شیراز - خیابان سعدی - پاساژ ملت - نبش خیابان فردوسی - فروشگاه مهران (فارم آسان)",
        "addressLocality": "شیراز",
        "addressCountry": "IR"
    },
    "sameAs": [
        "https://maps.app.goo.gl/1vqVsQ67XDTQKxSF9",
        "https://wa.me/+989101172004",
        "https://www.instagram.com/farm.asan?igsh=Nzd5d3dyNWY2MzJz"
    ]
};

const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "فارم آسان",
    "alternateName": [
        "FarmAsan",
        "Farm Asan"
    ],
    "url": "https://farmasan.ir/"
};


const AppContainer = styled.div`
  background-image: url("../assets/Images/COM_TOPKV_PC_img05.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  > div:first-of-type {
    flex:1 0 100vh;
  }
`


const MobContainer = styled.div`
  background-image: url("../assets/Images/COM_TOPKV_PC_img05.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  min-height: 40vh;
  > div:first-of-type {
    flex:1 0 40vh;
  }
`

const FooterContainer = styled.div`
  background-size: cover;
  background-color: #c4392f;
  display: flex;
  flex-direction: column;
  min-height: 50vh;
  > div:first-of-type {
    flex: 1 0 50vh;
  }
`

const ContactUsContainer = styled.div`
  background-size: cover;
  background-color: #2f4858;
  display: flex;
  flex-direction: column;
  min-height: 40vh;
  > div:first-of-type {
    flex: 1 0 40vh;
  }
`

const Container = styled.div`

  display: flex;
  flex-direction: column;
  min-height: 100vh;
  margin-top: 50px !important;
  > div:first-of-type {
    flex: 1 0 70vh;
  }
`






const PrivateLayout = ({ children }) => {
    //#region Const

    let navigate = ReactDOM.useNavigate();
    const [ProductGroupList, setProductGroupList] = React.useState([]);
    const [BrandList, setBrandList] = React.useState([]);


    //#endregion

    //#region OnChange
    const NavigatePage = (url) => {
        navigate(url)

    }


    const GetProductGroup = () => {
        fetch(General.ApiRoute() + '/ProductGroup/SearchForWeb', {
            method: 'Get',
            headers: {
                'ApiKey': General.APIKey(),
                'WebIsActive': 1,
                'IsActive': -1
            },
            credentials: 'include'
        })
            .then(res => res.json())
            .then(result => {
                var tmp = []
                for (var i = 0; i < result.length; i++) {
                    tmp.push({
                        id: result[i].id,
                        title: result[i].title,
                        isActive: result[i].isActive,
                        webIsActive: result[i].webIsActive,
                        parentId: result[i].parentId,
                        identityNo: result[i].identityNo,
                        photoTag: "",
                        children: result[i].children,

                    })
                }
                setProductGroupList(tmp)
            })
    }

    const GetBrand = () => {
        fetch(General.ApiRoute() + '/ProductBrand/GetForWeb', {
            method: 'Get',
            headers: {
                'ApiKey': General.APIKey(),
                'IsActive': 1
            },
            credentials: 'include'
        })
            .then(res => res.json())
            .then(result => {
                var tmp = []
                for (var i = 0; i < result.length; i++) {
                    if (i <= 6)
                        tmp.push({
                            id: result[i].id,
                            title: result[i].title

                        })
                    else {
                        tmp.push({
                            id: -1,
                            title: "مشاهده تمام برند ها..."

                        })
                        break;
                    }
                }
                setBrandList(tmp)
            })
    }

    //#endregion



    const LogOut = () => {
        var requestOptions = {
            method: "Post",
            credentials: "include",
        };

        trackPromise(
            fetch(General.ApiRoute() + "/User/Logout", requestOptions)
                .then((result) => {
                    navigate("/");
                })
                .catch((error) => { })
        );
    };

    React.useEffect(() => {

        GetProductGroup();
        GetBrand();
    }, []);


    return (
        <>
            <Helmet>
                <title>فروشگاه فارم آسان | تجهیزات کشاورزی و صنعتی</title>
                        <meta
                            name="description"
                            content="بازرگانی فارم آسان؛ عرضه‌کننده انواع تجهیزات کشاورزی، موتور برق، پمپ، کارواش، سمپاش و ابزار صنعتی در شیراز."
                        />
                <script type="application/ld+json">
                    {JSON.stringify(organizationSchema)}
                </script>

                <script type="application/ld+json">
                    {JSON.stringify(websiteSchema)}
                </script>
            </Helmet >
            <rsuite.Container className="overflow-x-hidden" >
                <rsuite.Content >
                    <rsuite.Grid fluid className="bg-white mb-0">
                        {isBrowser ?
                            <AppContainer>
                                <AnimatedNavbar duration={100} value={[ProductGroupList, BrandList]} />
                            </AppContainer>
                            :
                            <MobContainer>

                                <MobNavbar value={[ProductGroupList, BrandList]} />
                            </MobContainer>
                        }
                        <Container className='mt-3'>
                            {children}
                        </Container>
                        <ContactUsContainer>
                            <rsuite.Grid className="p-1 White_Text text-center pt-5" >
                                <rsuite.Row>
                                    <rsuite.Col xs={24}>
                                        <rsuite.Heading level={2} >
                                            ارتباط با ما
                                        </rsuite.Heading>
                                        <p className="mt-4 Font17">
                                            علت ارتباط با فارم آسان را انتخاب کنید
                                        </p>
                                    </rsuite.Col>
                                    <rsuite.Col xs={12} md={8} className="p-2">
                                        <rsuite.Button color="red" className="border border-2  p-4 Font17" size="lg" style={{ color: "#ffff" }} block appearance="subtle">
                                            خدمات پس از فروش
                                        </rsuite.Button>
                                    </rsuite.Col>
                                    <rsuite.Col xs={12} md={8} className="p-2">
                                        <rsuite.Button color="red" className="border border-2  p-4 Font17" size="lg" style={{ color: "#ffff" }} block appearance="subtle">
                                            خرید کالا
                                        </rsuite.Button>
                                    </rsuite.Col>
                                    <rsuite.Col xs={24} md={8} className="p-2">
                                        <rsuite.Button color="red" className="border border-2  p-4 Font17" size="lg" style={{ color: "#ffff" }} block appearance="subtle">
                                            مشاوره محصولات
                                        </rsuite.Button>
                                    </rsuite.Col>
                                </rsuite.Row>

                            </rsuite.Grid>

                        </ContactUsContainer>

                        <FooterContainer>
                            <rsuite.Grid className="p-1" >
                                <rsuite.Row className="pt-1">
                                    <rsuite.Col xs={24} sm={24} md={8} className="p-3 ">
                                        <rsuite.Heading onClick={() => NavigatePage("/Services")} level={6} className="Footer_HText pb-2">خدمات پس از فروش</rsuite.Heading>
                                        <rsuite.Heading onClick={() => NavigatePage("/CompareProduct")} level={6} className="Footer_HText pb-2 mt-4">مقایسه محصولات</rsuite.Heading>
                                        <rsuite.Heading onClick={() => NavigatePage("/MotorSuggestion")} level={6} className="Footer_HText pb-2 mt-4">پیشنهاد موتور برق</rsuite.Heading>
                                        <rsuite.Heading onClick={() => NavigatePage("/AboutUs")} level={6} className="Footer_HText pb-2 mt-4">درباره ما</rsuite.Heading>
                                        <rsuite.Heading onClick={() => NavigatePage("/ContactUs")} level={6} className="Footer_HText pb-2 mt-4">تماس با ما</rsuite.Heading>
                                        <rsuite.Heading onClick={() => NavigatePage("/FollowProduct")} level={6} className="Footer_HText pb-2 mt-4">  پیگیری مرسولات</rsuite.Heading>


                                    </rsuite.Col>
                                    <rsuite.Col xs={24} sm={24} md={8} className="p-3">
                                        <rsuite.Heading onClick={() => NavigatePage("/ParentGroup")} level={6} className="Footer_HText pb-2 mb-3 Cursor">محصولات</rsuite.Heading>
                                        {ProductGroupList.map(item => (

                                            <p onClick={() => NavigatePage("/Group/" + General.toSlug(item.title, { latin: true }) + "/" + item.id)} className="Footer_PText">{item.title}</p>

                                        ))}

                                    </rsuite.Col>
                                    <rsuite.Col xs={24} sm={24} md={8} className="p-3">

                                        <rsuite.Heading onClick={() => NavigatePage("/Brand")} level={6} className="Footer_HText pb-2 mb-3">برند</rsuite.Heading>
                                        {BrandList.map(item => (
                                            item.id != -1 ?
                                                <p onClick={() => NavigatePage("/ProductBrand/" + General.toSlug(item.title, { latin: true }) + "/" + item.id)} className="Footer_PText">{item.title}</p>
                                                :
                                                <p className="Footer_PText">....</p>



                                        ))}
                                    </rsuite.Col>

                                </rsuite.Row>

                            </rsuite.Grid>
                            <rsuite.Row className=" border-top border-5" >
                                <rsuite.Grid fluid className="p-3 ">
                                    <rsuite.Col xs={24} md={12} className="Font11  mt-2" style={{ color: "#ffff" }}>
                                        شیراز - خیابان سعدی - پاساژ ملت - نبش خیابان فردوسی - فروشگاه مهران (فارم آسان)
                                        <br />
                                        <ReactSocialMediaIcons className='pe-2 ps-2' borderColor="rgb(251, 251, 252, 0.0)" icon="instagram"
                                            iconColor="#ffff" backgroundColor="rgb(251, 251, 252, 0.0)"
                                            url="https://www.instagram.com/farm.asan?igsh=Nzd5d3dyNWY2MzJz" size="30" />

                                        <ReactSocialMediaIcons className='pe-2 ps-2' borderColor="rgb(251, 251, 252, 0.0)" icon="whatsapp"
                                            iconColor="#ffff" backgroundColor="rgb(251, 251, 252, 0.0)"
                                            url="https://wa.me/+989101172004" size="30" />

                                        <ReactSocialMediaIcons className='pe-2 ps-2' borderColor="rgb(251, 251, 252, 0.0)" icon="map"
                                            iconColor="#ffff" backgroundColor="rgb(251, 251, 252, 0.0)"
                                            url="https://maps.app.goo.gl/1vqVsQ67XDTQKxSF9" size="30" />

                                        <ReactSocialMediaIcons className='pe-2 ps-2' borderColor="rgb(251, 251, 252, 0.0)" icon="mail"
                                            iconColor="#ffff" backgroundColor="rgb(251, 251, 252, 0.0)"
                                            url="https://mail.google.com/mail/?view=cm&fs=1&to=Asma.dehghani@gmail.com" size="30" />

                                    </rsuite.Col>
                                    <rsuite.Col xs={24} md={12} className="text-left">
                                        <a referrerpolicy='origin' target='_blank'
                                            href='https://trustseal.enamad.ir/?id=603884&Code=hP2KKVOpE2ojv5Hqn7Pzunw4FSbPbmyh'>
                                            <img referrerpolicy='origin' src='https://trustseal.enamad.ir/logo.aspx?id=603884&Code=hP2KKVOpE2ojv5Hqn7Pzunw4FSbPbmyh' alt=''
                                                style={{ cursor: 'pointer', width: '70px' }} code='hP2KKVOpE2ojv5Hqn7Pzunw4FSbPbmyh' /></a>

                                        {/* <ReactSocialMediaIcons className='pe-2 ps-2' borderColor="rgb(251, 251, 252, 0.0)" icon="instagram"
                                            iconColor="#ffff" backgroundColor="rgb(251, 251, 252, 0.0)"
                                            url="https://www.instagram.com/farm.asan?igsh=Nzd5d3dyNWY2MzJz" size="30" />

                                        <ReactSocialMediaIcons className='pe-2 ps-2' borderColor="rgb(251, 251, 252, 0.0)" icon="whatsapp"
                                            iconColor="#ffff" backgroundColor="rgb(251, 251, 252, 0.0)"
                                            url="https://wa.me/+989101172004" size="30" />

                                        <ReactSocialMediaIcons className='pe-2 ps-2' borderColor="rgb(251, 251, 252, 0.0)" icon="map"
                                            iconColor="#ffff" backgroundColor="rgb(251, 251, 252, 0.0)"
                                            url="https://maps.app.goo.gl/1vqVsQ67XDTQKxSF9" size="30" />

                                        <ReactSocialMediaIcons className='pe-2 ps-2' borderColor="rgb(251, 251, 252, 0.0)" icon="mail"
                                            iconColor="#ffff" backgroundColor="rgb(251, 251, 252, 0.0)"
                                            url="https://mail.google.com/mail/?view=cm&fs=1&to=Asma.dehghani@gmail.com" size="30" />
                                     */}
                                    </rsuite.Col>


                                </rsuite.Grid>
                            </rsuite.Row>
                        </FooterContainer>


                    </rsuite.Grid>
                </rsuite.Content>
            </rsuite.Container>



        </>
    );
};

export default PrivateLayout;